// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-lekoarts-gatsby-theme-emilia-core-src-templates-project-query-tsx": () => import("./../../../node_modules/@lekoarts/gatsby-theme-emilia-core/src/templates/project-query.tsx" /* webpackChunkName: "component---node-modules-lekoarts-gatsby-theme-emilia-core-src-templates-project-query-tsx" */),
  "component---node-modules-lekoarts-gatsby-theme-emilia-core-src-templates-projects-query-tsx": () => import("./../../../node_modules/@lekoarts/gatsby-theme-emilia-core/src/templates/projects-query.tsx" /* webpackChunkName: "component---node-modules-lekoarts-gatsby-theme-emilia-core-src-templates-projects-query-tsx" */)
}

